import React, {  Component } from 'react';
import CountUp from 'react-countup';
import { createRegistrationStatus, dbQuery  } from "../../../api"
import {  User, Users, X, Check } from 'react-feather';

import '../../../index.scss';

class EventRegistrationCube extends Component {
    constructor(props) {
        super(props);
        this.qType = this.props.qType ? this.props.qType : 'number'
        this.state = {
            loading: true,
            data: 0,
            tUser: this.props.tUser
        }
    }

    doQuery = () => {
        if (this.props.query) {       
            dbQuery(this.props.query).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, loading: false});                    
                }
            });
        } else this.setState({ loading: false});                    

    };

    componentDidMount() {
        this.doQuery();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.tUser !== this.props.tUser) {
            this.setState({tUser: this.props.tUser});
        }
    }

    capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    
    render() {
        if (this.state.loading) { return null; }
        const {tUser} = this.state;
        const {tEvent} = this.props;
        var tUserEvent = tUser ? tUser.events.find(x=>x.eventId === tEvent._id) : null;
        var data = tEvent.competitorCount

        var icon = <User className="font-primary" />;
        if (tEvent.teamSize > 1) icon = <Users className="font-primary" />;

        const status = createRegistrationStatus(tUserEvent);
        var bg="bg-danger";
        if (status.startsWith( "Waiting")) bg="bg-warning";
        if (status === "Ready!") bg = "bg-primary"

        const smallText = <>
            {/*data >= tEvent.min &&*/ <>&nbsp;Registered.</>}
            &nbsp;&nbsp;&nbsp;{`Allowed: ${tEvent.min} - ${tEvent.max}`}
            &nbsp;&nbsp;&nbsp;{`Category: ${this.capitalize(tEvent.category)}`}
        </>
        const smallContent = <>{/*data >= tEvent.min &&*/ <CountUp className="counter" end={data} />}<small>{smallText}</small></>

        return (
            <div className="card o-hidden widget-cards">
                <div className={`${bg} card-body`}>
                    <div className="media static-top-widget row">
                        <div className="icons-widgets col-3">
                            <div className="align-self-center text-center">{icon}</div>
                            <div className="align-self-center text-center" style={{marginTop: "4px", backgroundColor: "white"}}>
                            {tUserEvent && tUserEvent.isRegistered
                                ?   status.startsWith('Waiting')
                                    ?   <span className="badge"><Check className="font-warning" /></span>
                                    :   <span className="badge"><Check className="font-secondary" /></span>
                                :   <span className="badge"><X className="font-warning" /></span>
                                }                            
                            </div>

                            
                        </div>
                        <div className="media-body col-9">
                            <span className="m-0">
                                <h3>{tEvent.title}&nbsp;<small>(${tEvent.fee.toFixed(2)})</small></h3>
                            </span>
                            <h3 className="mb-0">
                                {smallContent}
                            </h3>
                            <h3 className="mb-0" style={{marginTop: "8px"}}>
                                {tUserEvent && tUserEvent.isRegistered 
                                ?  <><small style={{fontSize: "18px"}}>{`My Status: ${status}`}</small></>
                                :  <><small style={{fontSize: "18px"}}>My Event Status: Not Registered</small></>
                                }                                
                            </h3>                            
                        </div>
                      
                    </div>
                </div>
            </div>    
        )
    }
}

export default EventRegistrationCube;